import React from 'react'
import PropTypes from 'prop-types'
import IconButton from '@material-ui/core/IconButton'
import CheckIcon from '@material-ui/icons/Check'
import { CheckboxWithLabel } from '../Fields'
import "./sectionSelect.scss"

const baseClass = 'section-select'

const SectionSelect = ({
  sections
}) => (
  <div className={`${baseClass}_wrapper`}>
    <div className={`${baseClass}__flex-container`}>
      {sections.map(({title, description}, index) => (
        <div key={`section-header-${index}`} className={`${baseClass}__column`}>
          <h5 className={`${baseClass}__header`}>{title}</h5>
          <small className={`${baseClass}__description`}>{description}</small>
        </div>
      ))}
    </div>
    <div className={`${baseClass}__flex-container`}>
      {sections.map(({canToggle = true, items}, index) => (
        <div key={`section-content-${index}`} className={`${baseClass}__column`}>
          {canToggle ? (
            items.map((item, index) => (
              <CheckboxWithLabel key={`optional-item-${index}`} label={item.label} name={item.name} />
            ))
          ) : (
            <div className={`${baseClass}__default-item-container`}>
              {items.map((item, index) => (
                <div key={`default-item-${index}`} className={`${baseClass}__default-item`}>
                  <IconButton disabled size="small"><CheckIcon /></IconButton>
                  <span>{item.label}</span>
                </div>
              ))}
            </div>
          )}
      </div>
      ))}
    </div>
  </div>
)

const sectionPropTypes = PropTypes.shape({
  canToggle: PropTypes.bool,
  title: PropTypes.string,
  description: PropTypes.string,
  items: PropTypes.array
})

SectionSelect.propTypes = {
  sections: PropTypes.arrayOf(sectionPropTypes)
}

export default SectionSelect
